import React, { useEffect, useRef, useState } from 'react';
//@ts-ignore
import NET from 'vanta/dist/vanta.net.min'; 
//@ts-ignore
import TRUNK from 'vanta/dist/vanta.trunk.min'; 
import { Info } from '../User';
import Typewriter from 'typewriter-effect';
import { Button, useMatches } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import ResumeViewer from './ResumeViewer';
import emailjs from 'emailjs-com';  

const About = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [net, setNet] = useState<any>(null);
  const [trunk, setTrunk] = useState<any>(null);
  const btn = useMatches({
    xs: "xs", sm: "sm", md: "md", lg: "lg"
  });

  useEffect(() => {
    if (!net) {
      setNet(NET({
        el: "#bg",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00,
        color: 0x45a88c,
        backgroundColor: 0x0A0A0A,
        points: 10.00,
        maxDistance: 20.00,
        spacing: 13.00
      }));
    }
    if (!trunk) {
      setTrunk(TRUNK({
        el: "#photo",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 100.00,
        minWidth: 100.00,
        scale: 1.00,
        scaleMobile: 1.00,
        color: 0x45a88c,
        backgroundColor: 0x0A0A0A,
        spacing: 0,
        chaos: 4.00
      }));
    }
    return () => {
      if (net) net.destroy();
      if (trunk) trunk.destroy();
    };
  }, [net, trunk]);

  const sendEmail = () => {
    const currentTime = new Date().toLocaleString();
    emailjs.send(
      'service_dqlozxr', 
      'template_xzzwgrw', 
      {
        message: 'Someone clicked the Check Resume button.',
        time_stamp: currentTime
      },
      'JZN8-2c7ZwSZ-m0DT' 
    ).then((result) => {
      console.log(result.text);
    }, (error) => {
      console.log(error.text);
    });
  };

  return (
    <>
      <div className="flex flex-col-reverse lg:flex-row justify-around items-center font-mono px-6 lg:px-16 h-auto lg:h-[100vh] sm:h-[150vh]" id="bg">
        <div className="mt-10 lg:mt-0 lg:w-3/5 flex flex-col">
          <div className="text-primaryColor text-xl sm:text-2xl lg:text-3xl lg:m-3 lg:mt-20" data-aos="fade-up" data-aos-duration="800">Hi, I am</div>
          <div className="text-white text-3xl sm:text-4xl lg:text-[4rem] font-extrabold lg:m-3 sm:items-center" data-aos="fade-up" data-aos-duration="800">{Info.name}</div>
          <div className="text-white text-lg sm:text-lg lg:text-4xl flex font-semibold lg:m-3" data-aos="fade-up" data-aos-duration="800">I'm a&nbsp;
            <span className="text-primaryColor sm:text-[2rem]" data-aos="fade-up" data-aos-duration="800">
              <Typewriter options={{ strings: Info.stack, autoStart: true, loop: true, }} />
            </span>
          </div>
          <div className="text-textColor text-base sm:text-lg lg:text-xl w-full lg:w-[90%] text-justify my-4 lg:my-8 font-semibold" data-aos="fade-up" data-aos-duration="800">
            {Info.bio}
          </div>
          <div className='flex flex-wrap gap-6'>
            <Button
              onClick={() => { open(); sendEmail(); }} 
              className="!text-primaryColor !w-fit flex justify-center items-center"
              size={btn}
              variant="outline"
              color="#64FFDA"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Check Resume
            </Button>
            <Button  onClick={() => { open(); sendEmail(); }} 
              className="!bg-primaryColor !w-fit flex justify-center items-center !text-bgColor"
              size={btn}
              variant='filled'
              color=""
              data-aos="fade-up"
              data-aos-duration="1000">Download</Button>
          </div>
        </div>
        <div className="mt-28 w-[60vw] xs:w-[50vw] sm:w-[30vw] lg:w-[20vw] h-auto lg:h-[45vh] lg:mt-0 flex justify-center items-center overflow-hidden rounded-full border-4 border-primaryColor shadow-[0_0_25px_rgba(100,255,218,0.6)]" id="photo" data-aos="zoom-in" data-aos-duration="1000">
          <img className="w-[100%] h-[100%] rounded-full shadow-lg" src="/nprofilec.jpg" alt="profile" data-aos="zoom-in" data-aos-duration="1000" />
        </div>
      </div>
      <ResumeViewer opened={opened} close={close} />
    </>
  );
};

export default About;
